<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="title" label="标题" width="180">
      </el-table-column>
      <el-table-column prop="type" label="分类" :formatter="getType" width="180">
      </el-table-column>
      <el-table-column prop="cover_url" label="封面">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 83px" :src="scope.row.cover_url"
          :preview-src-list="getPreview(scope.row)" fit="fit"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="news_url" label="新闻地址">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" @click="delNew(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" :total="total" :current-page="pageNum"
      :page-size="pageSize"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import Global from "../Global"

  export default {
    name: 'ManageNews',
    data() {
      return {
        tableData: [],
        newsType: [],
        total: 0,
        pageNum: 1,
        pageSize: 5
      }
    },
    mounted() {
      this.getAllNews()
      this.getNewsType()
    },
    methods: {
      // 获取所有新闻
      getAllNews() {
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + '/system/news/getAllNewsByData',
          params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            type: 0
          }
        }).then(resp => {
          this.total = resp.data.data.total
          this.tableData = resp.data.data.news
        })
      },
      // 获取所有新闻类型
      getNewsType() {
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + '/system/news/getNewsType'
        }).then(resp => {
          this.newsType = resp.data.data
        })
      },
      // 删除新闻
      delNew(row) {
        this.$confirm('是否删除这则新闻?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios({
            method: 'POST',
            url: Global.yunyingUrl + '/system/news/delNew',
            data: {
              id: row.id
            }
          }).then(resp => {
            if (resp.data.code === 1000) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getAllNews()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消下载'
          })
        })
      },
      // 获取当前列的类型
      getType(row) {
        let typeName
        this.newsType.forEach(element => {
          if (row.type === element.news_type) {
            typeName = element.news_name
          }
        })
        return typeName
      },
      // 改变页码
      handleCurrentChange(currentPageNum) {
        this.pageNum = currentPageNum
        this.getAllNews()
      },
      // 获取需要预览的图片
      getPreview(row) {
        let ans = []
        ans.push(row.cover_url)
        return ans
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/news_add/ManageNews.vue